import React, { useEffect, useState } from 'react';
import { Box, Typography, Fade } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo_swimteampro.png';

const SplashScreen = () => {
  const navigate = useNavigate();
  const [showContent, setShowContent] = useState(false);
  const version = 'Pro v1.0.0';

  useEffect(() => {
    const hasShownLogo = localStorage.getItem('hasShownLogo');
    const competitionStarted = localStorage.getItem('competitionStarted');
    const swimmers = localStorage.getItem('swimmers');

    if (hasShownLogo === 'true' && (competitionStarted === 'true' || swimmers)) {
      navigate('/register');
    } else {
      localStorage.setItem('hasShownLogo', 'true');
      setShowContent(true);
      const timer = setTimeout(() => {
        navigate('/register');
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [navigate]);

  return (
    <Box
      sx={{
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Fade in={showContent} timeout={1000}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 4
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              width: { xs: '240px', sm: '320px', md: '400px' },
              height: 'auto',
              objectFit: 'contain',
              maxWidth: '100%',
              animation: 'pulse 2s infinite',
              '@keyframes pulse': {
                '0%': {
                  transform: 'scale(1)',
                  opacity: 1
                },
                '50%': {
                  transform: 'scale(1.05)',
                  opacity: 0.8
                },
                '100%': {
                  transform: 'scale(1)',
                  opacity: 1
                }
              }
            }}
          />
          <Typography
            variant="subtitle1"
            sx={{
              opacity: 0.7,
              fontFamily: 'monospace',
              letterSpacing: 1,
              fontSize: { xs: '0.875rem', sm: '1rem' }
            }}
          >
            {version}
          </Typography>
        </Box>
      </Fade>
    </Box>
  );
};

export default SplashScreen;